module.exports = __webpack_public_path__ + "img/goods14_6.97046145.jpg";